// Hiding an element that may be SVG (P8.19, P8.20).
//
// `element.hidden = true` is an HTMLElement PROPERTY. An SVG `<g>` is not an
// HTMLElement, so the assignment lands as a plain JS expando and the booth
// stays on the drawing. The ATTRIBUTE is global and the stylesheet's
// `[hidden]` rule matches any element, so setting it is what actually hides
// one.
//
// Found by a system test watching three booths refuse to disappear, and then
// again by a picker whose zone filter did nothing — which is why it is one
// function in one place rather than a line each controller remembers.
export function setHidden(element, hidden) {
  if (hidden) element.setAttribute("hidden", "")
  else element.removeAttribute("hidden")
}
